<template>
  <vx-card class="min-h-screen">
		<ResponseAlert ref="response" />
		<vs-table
			:sst="true"
			@sort="sort"
      :data="config.rows"
      style="white-space: nowrap;"
		>
			<template slot="header">
				<vs-row class="my-5" vs-w="12" vs-justify="space-between">
          <vs-col vs-type="flex" vs-xs="12" vs-sm="7" vs-lg="6" vs-justify="space-between" class="gap-3">
            <div class="w-2/3">
              <div class="relative w-full">
                <i class="vs-icon notranslate icon-scale material-icons null absolute z-50" style="top: 12px; right: 10px">search</i>
                <vs-input class="w-full" placeholder="Search" v-model="config.search" @input="handleSearch"/>
              </div>
            </div>
            <div class="w-1/3 sm:w-1/2 lg:w-1/3">
              <vs-button @click="models.advance_search=true" class="w-full truncate px-0 text-xs sm:text-base h-full" color="primary" type="filled"><small>Advance Search</small></vs-button>
            </div>
          </vs-col>
					<vs-col vs-type="flex" vs-xs="12" vs-lg="4" vs-justify="space-between" class="gap-3 mt-2 sm:mt-0">
						<div class="w-1/2">
							<vs-button target @click="exportExcel" class="w-full" color="primary" type="filled"><small>Export</small></vs-button>
						</div>
						<div class="w-1/2 px-0">
							<vs-button @click="vars.importPopup = true" class="w-full px-0" color="primary" type="filled" icon="folder"><small>Import Resi </small></vs-button>
						</div>
					</vs-col>
				</vs-row>
      </template>
			<template slot="thead">
				<vs-th :sort-key="row.value" v-for="(row, key) in config.headers" :key="key" :width="row.width" :class="row.class">
					{{row.title}}
				</vs-th>
			</template>
			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td :data="data[indextr].user">
						{{data[indextr].user && data[indextr].user.name}}
					</vs-td>

					<vs-td :data="data[indextr].createdAt">
						{{moment(data[indextr].createdAt).format('DD MMM YYYY')}}
					</vs-td>

					<vs-td :data="data[indextr].product">
						{{data[indextr].product && truncate(data[indextr].product.name, 50)}}
					</vs-td>

					<vs-td :data="data[indextr].invoiceId">
						{{data[indextr].invoiceId}}
					</vs-td>

					<vs-td :data="data[indextr].amount">
						{{data[indextr].amount}}
					</vs-td>

					<vs-td :data="data[indextr].awb">
						{{data[indextr].awb}}
					</vs-td>

					<vs-td :data="data[indextr].internalStatus" :class="textColor(data[indextr].status)" class="font-bold">
						<small>{{data[indextr].internalStatus}}</small>
					</vs-td>

					<vs-td>
						<div class="flex flex-row justify-between items-center">
							<vs-button :to='`/${config.uri}/${data[indextr].id}`' title="Detail" color="dark" type="flat" icon="visibility"></vs-button>
							<vs-button v-if="data[indextr].status === 0 && !data[indextr].status && !data[indextr].transactionId" @click="updateClaim(data[indextr].id, 1)" title="Process" color="success" type="flat" icon="done"></vs-button>
							<vs-button v-if="data[indextr].status === 0 && !data[indextr].status && !data[indextr].transactionId" @click="reject(data[indextr].id, 4)" title="Reject" color="danger" type="flat" icon="close"></vs-button>						
							<vs-button v-if="data[indextr].status === 1" @click="updateClaim(data[indextr].id, 2)" title="Send Product" color="primary" type="flat" icon="send"></vs-button>
						<vs-button v-if="data[indextr].status === 1" @click="reject(data[indextr].id, 4)" title="Reject" color="danger" type="flat" icon="close"></vs-button>						</div>
          </vs-td>
				</vs-tr>
			</template>
		</vs-table>

		<Pagination :config="config" @gotoPage="gotoPage"/>

		<vs-popup button-close-hidden title="Search" :active.sync="models.advance_search">
			<vs-row>
				<vs-col vs-type="flex" class="flex-col pr-1" vs-w="12">
					<vs-row>
						<vs-col class="flex-col pr-1" vs-type="flex" vs-lg="6">
							<label for="start_date">Start Date</label>
							<vs-input
								autocomplete="off"
								type="date"
								v-model="models.start_date"
								class="w-full"/>
						</vs-col>
						<vs-col class="flex-col pl-1" vs-type="flex" vs-lg="6">
							<label for="end_date">End Date</label>
							<vs-input
								name="end date"
								type="date"
								v-model="models.end_date"
								v-validate="vars.endValidate"
								:min="vars.end_date"
								class="w-full"/>
								<span class="text-danger text-sm" v-show="errors.has('end date')">{{ errors.first('end date') }}</span>
						</vs-col>
					</vs-row>
				</vs-col>
			</vs-row>
			<vs-row class="mt-5">
				<vs-col vs-type="flex" class="flex-col pr-1" vs-w="12">
					<select class="w-full" v-model="models.status">
						<option v-for="(status, index) in masters.statuses" :key="index" :value="status.value">{{status.text}}</option>
					</select>
				</vs-col>
			</vs-row>
			<vs-row class="mt-5">
				<vs-col vs-type="flex" class="flex-col" vs-w="8" vs-xs="12">
					<vs-row>
						<vs-col vs-type="flex" vs-lg="4" class="px-0">
							<vs-button @click="advanceSearch" class="w-full" color="success">Submit</vs-button>
						</vs-col>
						<vs-col vs-type="flex" vs-lg="4" class="px-1">
							<vs-button @click="reset" class="w-full" color="warning">Reset</vs-button>
						</vs-col>
						<vs-col vs-type="flex" vs-lg="4" class="px-0">
							<vs-button @click="models.advance_search = false" class="w-full" color="danger">Cancel</vs-button>
						</vs-col>
					</vs-row>
				</vs-col>
			</vs-row>
		</vs-popup>

    <vs-popup title="Import Resi" :active.sync="vars.importPopup">
      <ImportExcel templateUrl="/templates/import-awb-redeem.xlsx" v-model="vars.awbFile" @handleUpload="handleUploadAwb"/>
    </vs-popup>
	</vx-card>
</template>

<script>
import moment from 'moment'
import {getColorStatus, truncate} from '@/utils/helpers'
import ImportExcel from "../../components/excel/ImportExcel.vue";
import api from '@/utils/api'
export default {
		name: 'ListClaim',
    components: {
      ImportExcel
    },
		data() {
			return {
				config: {
					uri: this.$route.meta.link,
					api: api.redeems,
					rows: [],
					total_data: 0,
					total_page: 0,
					per_page: 10,
					page: 1,
					orderby: "id",
					sort: "desc",
					additional_params: {
						status: null,
						createdAt: null
					},
					search: "",
					debounce: null,
					headers: [{
						title: "User",
						value: "user.name",
						align: "text-left",
						width: "25%",
					}, {
						title: "Date",
						value: "createdAt",
						align: "text-left",
						width: "15%",
					}, {
						title: "Product",
						value: "product.name",
						align: "text-left",
						width: "15%",
					}, {
						title: "Invoice",
						value: "invoiceId",
						align: "text-left",
						width: "15%",
					},  {
						title: "Point Balance",
						value: "amount",
						align: "text-left",
						width: "15%",
					}, {
						title: "No. Resi",
						value: "awb",
						align: "text-left",
						width: "15%",
					}, {
						title: "Status",
						value: "status",
						align: "text-left",
						width: "15%",
					}, {
						title: "Action",
						value: "",
						class: "text-center",
						width: "15%",
					}],
				},
				models: {
					advance_search: false,
					status: null,
					start_date: null,
					end_date: null
				},
				vars: {
					end_date: moment().format('YYYY-MM-DD'),
					endValidate: '',
          importPopup: false,
          awbFile: null
				},
				masters: {
					statuses: [
						{
							text: 'All Status',
							value: null
						},
						{
							text: 'Waiting Process',
							value: 0
						},
						{
							text: 'Processing',
							value: 1
						},
						{
							text: 'Product Sent',
							value: 2
						},
						{
							text: 'Product Receive',
							value: 3
						},
						{
							text: 'Reject',
							value: 4
						},
					]
				},
				moment,
				getColorStatus,
        truncate
			}
		},
		computed: {
			start_date() {
				return this.models.start_date
			}
		},
		created() {
			const _ = this;
			_.get();
		},
    watch: {
      'config.per_page'() {
        this.config.page = 1
        this.get()
      }
    },
		methods: {
      handleUploadAwb() {
        const form = new FormData()
        form.append('file', this.vars.awbFile)
        this.$axios.post('/redeems/import-awb', form)
          .then(() => {
            this.$vs.notify({
              title: 'Success',
              text: 'Success import file',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success'
            })

            this.vars.importPopup = false
            this.vars.awbFile = null
            this.get()
          })
          .catch((err) => {
            this.$vs.notify({
              title: 'Failed',
              text: err.response.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })
      },
			exportExcel(){
				const config = this.config
        const additional_params = config.additional_params || {}
        const search = {search: config.search}
				this.$axios.get(api.exportExcel, {
						params: Object.assign(search, additional_params),
						responseType: 'blob',
						headers: {
							Authorization: "Bearer " + localStorage.getItem('token')
						}
					}
				).then((response) => {
					const blob = new Blob(
					[response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
                    const aEle = document.createElement('a');     // Create a label
                    const href = window.URL.createObjectURL(blob);       // Create downloaded link
                    aEle.href = href;
                    aEle.download = `Report (${moment().format('DD MMMM YYYY')})`;  // File name after download
                    document.body.appendChild(aEle);
                    aEle.click();     // Click to download
                    document.body.removeChild(aEle); // Download complete remove element
                    window.URL.revokeObjectURL(href) // Release blob object
				});
			},
			get() {
				this.$table.get(this.config)
					.then(() => {
						this.$watch('start_date', () => {
							this.vars.end_date = moment(this.models.start_date).format('YYYY-MM-DD')
							if (moment(this.models.start_date).isAfter(this.models.end_date)) {
								this.models.end_date = moment(this.models.start_date).format('YYYY-MM-DD')
							}
							this.vars.endValidate = this.models.start_date ? 'required' : ''
						})
					})
			},
			sort(orderby) {
				if(orderby !== "") this.$table.sort(this.config, orderby)
			},
			gotoPage(page) {
				this.$table.gotoPage(this.config, page)
			},
			reject(id, status) {
				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: "Confirm",
					text: "Are you sure want to reject this request?",
					acceptText: "Yes",
					cancelText: "No",
					accept: () => {
						this.updateClaim(id, status)
					}
				})
			},

			updateClaim(id, status) {
				// status: (0: waiting process, 1: processing, 2: product-sent, 3: product-receive, 4: reject)
				this.$axios.put(`${api.redeems}/${id}/status`, {
					status
				})
					.then(res => {
						this.$refs.response.setResponse(res.data, 'success');
						this.get()
					})
					.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'))
			},

			textColor(status) {
				switch (status) {
					case 0:
						return 'text-warning'
					case 1:
					case 2:
					case 3:
						return 'text-success'
					case 4:
						return 'text-danger'
					default:
						break;
				}
			},

			advanceSearch() {
				this.$validator.validate().then(async valid => {
					if (valid) {
						this.models.advance_search = false
						this.config.additional_params.status = this.models.status
						if(this.models.start_date) {
							this.config.additional_params.createdAt = `betweenDate:${moment(this.models.start_date).format('YYYY-MM-DD')},${moment(this.models.end_date).format('YYYY-MM-DD')}`
						}
						this.get()
					}}
				)
			},

			reset() {
				this.config.additional_params.status = null
				this.config.additional_params.createdAt = null

				this.models.start_date = null
				this.models.status = null
				this.models.end_date = null
				this.models.advance_search = false
				this.get()
			},

			handleSearch() {
				clearTimeout(this.debounce)
				this.debounce = setTimeout(() => {
          this.config.page = 1
          this.get()
				}, 300)
			},
		},
	}
</script>

<style>

</style>
